import { fmtNum } from '@/features/ah/utils';
import type { PrijsfavorietenPart } from '../report';
import { pairPages } from '../utils';
import { PairedBars, PartLegend, type PartLabels } from './PartCompare';

/*
 * 04 — Gebruikersgedrag, two-part layout: informative-page opens of the running
 * part with Deel 1's total underneath, and the pages as Deel 1 / Deel 2 pairs.
 */

export function CompareBehaviourSection({ previous, current }: { previous: PrijsfavorietenPart; current: PrijsfavorietenPart }) {
  const labels: PartLabels = { previous: previous.campaign.periodLabel, current: current.campaign.periodLabel };
  const rows = pairPages(previous.behaviour, current.behaviour);
  // Counts, not shares: both parts on ONE axis, so a shorter bar really is fewer opens.
  const scale = Math.max(1, ...rows.flatMap((r) => [r.previous, r.current]));

  return (
    <section id="gebruikersgedrag" className="section">
      <div className="section-head">
        <div>
          <div className="eyebrow">04 — Gebruikersgedrag</div>
          <h2>Navigatie &amp; ondersteuning</h2>
        </div>
      </div>
      <div className="grid-1-2 pf-grid-stack">
        <div className="card">
          <div className="card-head">
            <h3>Informatieve pagina&rsquo;s geopend</h3>
            <span className="meta">{labels.current}</span>
          </div>
          <div className="ah-stat-huge">{current.campaign.currentDay > 0 ? fmtNum(current.behaviour.infoPagesTotal) : '—'}</div>
          <div className="pf-prev-total">
            <span className="k">{labels.previous} · totaal</span>
            <span className="v">{fmtNum(previous.behaviour.infoPagesTotal)}</span>
          </div>
        </div>
        <div className="card">
          <div className="card-head pf-card-head-wrap">
            <h3>Populairste pagina&rsquo;s</h3>
            <PartLegend labels={labels} />
          </div>
          <div className="pf-bar-note">Balk: D1 vs D2 per pagina</div>
          <PairedBars rows={rows} format={fmtNum} scale={scale} short={{ previous: 'D1', current: 'D2' }} />
        </div>
      </div>
    </section>
  );
}
